/* ==========================================================================
   TURF FACTORY MELBOURNE — Turf quote calculator
   Roll-width-aware sq ft stepper + live price estimate + quote handoff.

   Mount: [data-turf-calc] with data attributes:
     data-price-sqft, data-roll-width, data-max-length,
     data-product (handle), data-quote-url
   ========================================================================== */
(function () {
  'use strict';

  function money(n) {
    return '$' + n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function initCalc(root) {
    var pricePerSqft = parseFloat(root.dataset.priceSqft) || 0;
    var rollWidth = parseInt(root.dataset.rollWidth, 10) || 15;
    var maxLength = parseInt(root.dataset.maxLength, 10) || 100;
    var handle = root.dataset.product || '';
    var quoteUrl = root.dataset.quoteUrl || '/pages/quote';

    var step = rollWidth;                 // 1 linear ft of a full-width roll
    var minSqft = rollWidth;
    var maxSqft = rollWidth * maxLength;

    var input = root.querySelector('[data-calc-input]');
    var dec = root.querySelector('[data-calc-dec]');
    var inc = root.querySelector('[data-calc-inc]');
    var readout = root.querySelector('[data-calc-readout]');
    var quoteBtn = root.querySelector('[data-calc-quote]');

    function snap(v) {
      if (isNaN(v)) v = minSqft;
      v = Math.round(v / step) * step;
      if (v < minSqft) v = minSqft;
      if (v > maxSqft) v = maxSqft;
      return v;
    }

    function fulfillment() {
      var sel = root.querySelector('[name="turf_fulfillment"]:checked');
      return sel ? sel.value : 'install';
    }

    function render() {
      var sqft = snap(parseFloat(input.value));
      input.value = sqft;
      var linearFt = sqft / rollWidth;
      var est = sqft * pricePerSqft;
      if (readout) {
        if (pricePerSqft > 0) {
          readout.innerHTML = linearFt + ' linear ft &times; ' + rollWidth + ' ft wide = <strong>' + sqft +
            ' sq ft</strong> &middot; est. material <strong>' + money(est) + '</strong>' +
            '<span class="turf-calc__fine">Final quote confirms cut, freight &amp; install. Cut from ' +
            rollWidth + ' ft rolls (max ' + maxLength + ' ft).</span>';
        } else {
          readout.innerHTML = '<strong>' + sqft + ' sq ft</strong> (' + linearFt + ' linear ft of ' +
            rollWidth + ' ft roll). Request a quote for pricing.';
        }
      }
    }

    if (dec) dec.addEventListener('click', function () { input.value = snap(parseFloat(input.value) - step); render(); });
    if (inc) inc.addEventListener('click', function () { input.value = snap(parseFloat(input.value) + step); render(); });
    if (input) { input.addEventListener('change', render); input.addEventListener('blur', render); }
    root.querySelectorAll('[name="turf_fulfillment"]').forEach(function (el) { el.addEventListener('change', render); });

    if (quoteBtn) {
      quoteBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var sqft = snap(parseFloat(input.value));
        var p = new URLSearchParams();
        if (handle) p.set('product', handle);
        p.set('sqft', sqft);
        p.set('fulfillment', fulfillment());
        window.location.href = quoteUrl + '?' + p.toString();
      });
    }

    if (input && !input.value) input.value = minSqft;
    render();
  }

  function boot() {
    document.querySelectorAll('[data-turf-calc]').forEach(initCalc);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
